package com.tixforgigs.common

import kotlin.Boolean
import kotlin.String

internal object CommonBuildKonfig {
  public val API_VERSION: String = "4.6.297-SNAPSHOT"

  public val API_DEV_HOST: String = "https://dev.tixforgigs.com"

  public val API_STAGING_HOST: String = "https://staging.api.tixforgigs.shop"

  public val API_PROD_HOST: String = "https://staging.api.tixforgigs.shop"

  public val API_COMMON_PATH: String = "/common/v4.6"

  public val AUTH_DEV_HOST: String = "https://dev.tixforgigs.com"

  public val AUTH_DEV_PATH: String = "/auth"

  public val AUTH_STAGING_HOST: String = "https://staging.auth.tixforgigs.shop"

  public val AUTH_PROD_HOST: String = "https://staging.auth.tixforgigs.shop"

  public val MATOMO_URL: String = "https://ping.company.tixforgigs.com/dev/ping"

  public val WSS_URL: String = "wss://api.tix.support/service/updates"

  public val CONFIGURATOR_URL: String = "https://staging.tixforgigs.shop"

  public val STOREFRONT_URL: String = "https://staging.tixforgigs.shop"

  public val CLIENT_VERSION: String = "4.6.197-preview.570304.2"

  public val BUILD_TIMESTAMP: String = "2026-02-26T04:03:41+0100"

  public val PREPAYMENT_PAYEE: String = "TixforGigs - Fluffy Clouds GmbH & Co. KG"

  public val PREPAYMENT_IBAN: String = "DE11 4343 4343 4343 4343 43"

  public val PREPAYMENT_BIC: String = "GENODEF1HH2"

  public val TEST: Boolean = false

  public val TEST_USER: String = ""

  public val TEST_PASS: String = ""

  public val TEST_GN: String = ""

  public val TEST_SN: String = ""

  public val TEST_DOB: String = ""

  public val TEST_IBAN: String = ""

  public val TEST_BIC: String = ""

  public val TEST_BANK: String = ""
}
